import Main from './PartnerServicesMain'
import New from './PartnerServicesNew'
import Edit from './PartnerServicesEdit'
import Show from './PartnerServicesShow'

const partnerService = { Main, New, Edit, Show }

export default partnerService
